(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSBajaController', SSBajaController);

    SSBajaController.$inject = ['SSBaja'];

    function SSBajaController(SSBaja) {

        var vm = this;

        vm.sSBajas = [];

        loadAll();

        function loadAll() {
            SSBaja.query(function(result) {
                vm.sSBajas = result;
                vm.searchQuery = null;
            });
        }
    }
})();
